module.exports = __webpack_public_path__ + "static/media/icon-sel-device.ff274cf6.png";